// Change product image on swatch hover to the image associated with the swatch colour.

// Step 1: Add a hover listener to the colour swatches, and get the image associated with the colour
// Step 2: Get the product image using js, and swap out the image for the new image
// Step 3: Reset on mouseout. 

function initialiseSwatches(product) {

    const swatches = product.querySelector('.colour-swatch-wrapper');
    if (!swatches) return;

    const swatchItems = swatches.querySelectorAll('.colour-swatch-item-collection');

    // Find the original image for the product
    const mainImage = product.querySelector('img.product-first-img, .image-wrapper img');
    if (!mainImage) return;

    // Save original image if not already saved to be restored later
    if (!mainImage.dataset.original) {
        mainImage.dataset.original = mainImage.src;
        mainImage.dataset.original = mainImage.srcset || '';
        mainImage.dataset.originalDataSrcset = mainImage.getAttribute('data-srcset') || '';
    }

    // Change the image when hovering on a swatch
    swatchItems.forEach(swatch => {
        const link = swatch.querySelector('.colour-swatch-link-collection');
        if (!link) return;

        // Get the product URL to fetch the product data later
        let handleUrl = swatch.dataset.handle || link.getAttribute('href');
        if (!handleUrl) return;

        let handle = handleUrl.replace('/products', ''); // Instead of /products/product-url, just /product-url
        if (!handle) return;

        swatch.addEventListener('mouseenter', () => {
            // Get the product by its handle
            fetch(`/products/${handle}.js`)
                // Get the product data and parse it into JSON
                .then(res => {
                    if (!res.ok) throw new Error(`Product ${handle} not found`);
                    return res.json();
                })
                .then(product => {
                    // Gets the first image for the product
                    const newImageUrl = product.images?.[0];
                    if (!newImageUrl) return;

                    // Replace the product image with the new image
                    const baseUrl = newImageUrl;
                    const srcset = [
                        `${baseUrl}_180x.jpg 180w`,
                        `${baseUrl}_360x.jpg 360w`,
                        `${baseUrl}_540x.jpg 540w`,
                        `${baseUrl}_720x.jpg 720w`,
                        `${baseUrl}_900x.jpg 900w`,
                        `${baseUrl}_1080x.jpg 1080w`,
                        `${baseUrl}_1296x.jpg 1296w`,
                        `${baseUrl}_1512x.jpg 1512w`,
                        `${baseUrl}_1728x.jpg 1728w`
                    ].join(', ');

                    if (mainImage) {
                        // Sets all the srcs to the new image URL
                        mainImage.src = newImageUrl;
                        mainImage.srcset = srcset;
                        mainImage.setAttribute('data-srcset', srcset);
                    }
                })
            .catch(err => console.error("Swatch fetch error:", err));
        });
    });

    // Restore original image on mouseleave
    swatches.addEventListener('mouseleave', () => {
        mainImage.src = mainImage.dataset.original;
        mainImage.srcset = mainImage.dataset.original;
        mainImage.setAttribute('data-srcset', mainImage.dataset.original);
    });
}

// Observe for products added by infinite scroll
if (typeof infiniteLoadObserver === 'undefined') {
    const infiniteLoadObserver = new MutationObserver(mutations => {
    const productsToInit = new Set();

    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (!(node instanceof HTMLElement)) return;
            if (node.matches('.yv-product-card')) {
                productsToInit.add(node);
            }
            const productCard = node.querySelectorAll('.yv-product-card');
            if (productCard) {
                productCard.forEach(p =>  {
                    productsToInit.add(p);
                });
            }
        });
    });
        productsToInit.forEach(initialiseSwatches);
    });

    infiniteLoadObserver.observe(document.body, { childList: true, subtree: true });
}

// Initialize all existing products on page load
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.yv-product-card').forEach(initialiseSwatches);
});